import { EXTENSION_ID } from '../src/constants'

export const sendExtensionMessage = (data: any) => {
  let evnt = new CustomEvent('chirpExt', { detail: data })
  window.dispatchEvent(evnt)
}

export interface ExtensionMessagePayload {
  CHR_AUTH_SESSION: { auth: unknown }
  CHR_SIGN_OUT: undefined
  CHR_DECLARATION_COMPLETE: { shareLinkDeclaredAt: string }
}

export type ExtensionMessageType = keyof ExtensionMessagePayload

export function sendToExtension<T extends ExtensionMessageType>(
  type: T,
  payload?: ExtensionMessagePayload[T]
) {
  if (window.chrome?.runtime?.sendMessage) {
    window.chrome.runtime.sendMessage(EXTENSION_ID, { type, payload }, () => {
      if (window.chrome?.runtime?.lastError) {
        // Extension not installed or not responding
        console.log('Extension not available')
      } else {
        console.log('Message sent successfully')
      }
    })
  }
}
